import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./Column.module.scss";
const mainBreakpoints = ["xs", "sm", "md", "lg"];
const specificBreakpoints = [
    "xSmall",
    "smallMedium",
    "smallLarge",
    "medium",
    "mediumWide",
    "large",
    "largeMedium",
];
export const gridBreakpoints = [...mainBreakpoints, ...specificBreakpoints];
export const generateColumnWidthClassNames = (breakpoint) => {
    const columnWidths = Array.from({ length: 12 }).map((_, index) => index + 1);
    return columnWidths.reduce((acc, index) => {
        acc[index] = styles[`column-${breakpoint}-${index}`];
        return acc;
    }, {});
};
export const generateColumnClassNames = (breakpoints) => {
    return breakpoints.reduce((acc, breakpoint) => {
        acc[breakpoint] = generateColumnWidthClassNames(breakpoint);
        return acc;
    }, {});
};
const columnClassNames = generateColumnClassNames(gridBreakpoints);
const DEFAULT_COLUMN_SIZE = 12;
export const Column = ({ children, component, className, dataTestId, md, sm, xs = DEFAULT_COLUMN_SIZE, lg, specificBreakpoints, }) => {
    const Component = component || "div";
    return (_jsx(Component, { className: classNames(styles.column, className, columnClassNames.md[md], columnClassNames.sm[sm], columnClassNames.xs[xs], columnClassNames.lg[lg], columnClassNames.large[specificBreakpoints?.large], columnClassNames.largeMedium[specificBreakpoints?.largeMedium], columnClassNames.medium[specificBreakpoints?.medium], columnClassNames.mediumWide[specificBreakpoints?.mediumWide], columnClassNames.xSmall[specificBreakpoints?.xSmall], columnClassNames.smallMedium[specificBreakpoints?.smallMedium], columnClassNames.smallLarge[specificBreakpoints?.smallLarge]), "data-testid": dataTestId, children: children }));
};
//# sourceMappingURL=Column.js.map